var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$i18n.locale === 'ru')?[_c('NestRu')]:[_c('NestEn')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }